import styles from '../DocumentsToProjectsItem.module.scss';
import {Button, Image} from "../../../../../../../components";
import React, {useState} from "react";
import {Agreement} from "../../../../../../../api-client/models/documents/Agreement";
import {formatDate} from "../../../../../../../formatters";
import documentIcon from "../../../../../../../assets/images/svg/document.svg";
import FileSize from "../../../../../../../components/common/utils/FileSize/FileSize";
import dots from "../../../../../../../assets/images/svg/dots-green.svg";
import {downloadPDF} from "../../../../../../../utils/downloadPDF";

interface Props {
    document: Agreement
}

export const AutoinvestDocumentsItem = ({document}: Props) => {
  const [activeDownload, setActiveDownload] = useState(false);

  return (<ul className={styles.documentsToProjectBody__list}>
    <li>
      <div className={styles.documentsToProjectBody__item}>
        <Image className={styles.documentsToProjectBody__icon} src={documentIcon}/>
        <a className={styles.documentsToProjectBody__title}
          href={document.file.url}
          target="_blank" rel="noreferrer"
        >Общее агентское поручение
        </a>
        <a className={styles.documentsToProjectBody__size}
          href={document.file.url}
          target="_blank" rel="noreferrer"
        >pdf, <FileSize file={document.file}/></a>
        <a className={styles.documentsToProjectBody__watch}
          href={document.file.url}
          target="_blank" rel="noreferrer">Нажмите, чтобы посмотреть
        </a>
        <a
          className={styles.documentsToProjectBody__date}
          href={document.file.url}
          target="_blank" rel="noreferrer">{formatDate(document.createdAt)}</a>
        <a className={styles.documentsToProjectBody__dateText}
          href={document.file.url}
          target="_blank" rel="noreferrer">дата подписания
        </a>
        {document.digitalSign && <div
          className={styles.documentsToProjectBody__makeReport}>
          <Button className={styles.documentsToProjectBody__buttonSave}
            onClick={() => setActiveDownload((prevState) => !prevState)}>
            скачать <Image className={styles.documentsToProjectItemTitle__arrowButton__image__download}
              src={dots}/>
          </Button>
          {activeDownload && <div className={styles.documentsToProjectBody__download}>
            <Button className={styles.documentsToProjectBody__buttonDownload}
              onClick={() => downloadPDF(`${document.file.url}`, document.file.name)}>
              скачать PDF
            </Button>
          </div>}
        </div>}
      </div>
    </li>
  </ul>);
};
